import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { bookingList, getRoomAvailabilityList } from "../services/bookingReservation";
import moment from "moment";

export const getBookingList = createAsyncThunk(
  "getBookingList",
  async (payload) => {
    const data = {
      startDate: payload.startDate,
      endDate: payload.endDate,
      hotelId: payload.hotelId,
      statuses: payload.statuses,
      pageSize: 1000,
      paginationEnabled: true,
    };

    try {
      const response = await bookingList({ ...payload, ...data }, "bookings");
      return response;
    } catch (error) {
      return error;
    }
  }
);

 // — fetch date-wise room availability from your new API
 export const getRoomAvailability = createAsyncThunk(
   "getRoomAvailability",
   async ({ hotelId, startDate, endDate }, { rejectWithValue }) => {
     try {
       // assume this calls GET /rooms/date-wise-availability?hotelId=…&startDate=…&endDate=…
       const resp = await getRoomAvailabilityList({
         hotelId,
         startDate: startDate,
         endDate: endDate,
       });
       return resp;
     } catch (err) {
       return rejectWithValue(err.response?.data || err.message);
     }
   }
 );

const initialState = {
  fromDate: moment().startOf("day"),
  toDate: moment().add(6, "day"),
  bookingResponse: [], // store  booking list json data into it
  searchData: [],
  displayCustomCalendar: false,
  selectedCheckInDate: "",
  selectedCheckOutDate: "",
  openFilter: false,
  filterTitle: "Week",
  displayMobileViewDownloadAndPrint: false,
  roomsLoading: false,
  roomsError:   false,
  roomsData:    [],    // will hold the RoomAvailabilityDto[]
};

export const bookingReservationSlice = createSlice({
  name: "bookingReservation",
  initialState,
  reducers: {
    CLEAR_REDUX_STORE_13: () => initialState,

    updateDates: (state, actions) => {
      if (actions.payload.from) {
        state.fromDate = actions.payload.from;
        state.toDate = actions.payload.to;
      } else if (actions.payload.to) {
        state.toDate = actions.payload.to;
      } else {
        state.fromDate = moment().startOf("day");
        state.toDate = moment().add(6, "day");
      }
    },
    updateDisplayCustomCalendar: (state, action) => {
      state.displayCustomCalendar = action.payload;
    },
    updateSelectedCheckInDate: (state, action) => {
      state.selectedCheckInDate = action.payload;
    },
    updateSelectedCheckOutDate: (state, action) => {
      state.selectedCheckOutDate = action.payload;
    },
    updateDisplayFilter: (state, action) => {
      state.openFilter = action.payload;
    },

    updateSetFilterTitle: (state, action) => {
      state.filterTitle = action.payload;
    },

    searchUser: (state, action) => {
      state.searchData = action.payload;
    },

    updateBookingListData: (state, action) => {
      state.loading = action.payload.loading;
      state.bookingResponse = action.payload;
      state.apiError = action.payload.apiError;
    },
    updateDisplayMobileDownloadAndPrintModal: (state, action) => {
      state.displayMobileViewDownloadAndPrint = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getBookingList.pending, (state, action) => {
      state.loading = true;
      state.bookingResponse = [];
      state.apiError = false;
    });
    builder.addCase(getBookingList.fulfilled, (state, action) => {
      state.loading = false;
      state.bookingResponse = action.payload;
      // state.bookingResponse = [];
      state.apiError = false;
    });
    builder.addCase(getBookingList.rejected, (state, action) => {
      state.loading = false;
      state.bookingResponse = [];
      state.apiError = true;
    });
       builder.addCase(getRoomAvailability.pending, (state) => {
     state.roomsLoading = true;
     state.roomsError   = false;
     state.roomsData    = [];
   });
   builder.addCase(getRoomAvailability.fulfilled, (state, action) => {
     state.roomsLoading = false;
     state.roomsData    = action.payload;
     state.roomsError   = false;
   });
   builder.addCase(getRoomAvailability.rejected, (state) => {
     state.roomsLoading = false;
     state.roomsData    = [];
     state.roomsError   = true;
   });
  },
});

export const {
  CLEAR_REDUX_STORE_13,
  updateDates,
  searchUser,
  updateDisplayCustomCalendar,
  updateSelectedCheckInDate,
  updateSelectedCheckOutDate,
  updateDisplayFilter,
  updateSetFilterTitle,
  updateBookingListData,
  updateDisplayMobileDownloadAndPrintModal,
} = bookingReservationSlice.actions;

export default bookingReservationSlice.reducer;

